import { useEffect, useCallback } from 'react'
import { ZENDESK_KEY } from 'utils/constants'
import { getZESettings, getVisitorInfo } from './utils'

const canUseDOM = () => {
  if (typeof window === 'undefined' || !window.document || !window.document.createElement) {
    return false
  }
  return true
}

const Zendesk = ({ onLoaded, isVisible }) => {
  const onScriptLoaded = useCallback(() => {
    if (typeof onLoaded === 'function') {
      onLoaded()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLoaded])

  const insertScript = useCallback(
    zendeskKey => {
      const script = document.createElement('script')
      script.async = true
      script.id = 'ze-snippet'
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`
      script.addEventListener('load', onScriptLoaded)
      document.body.appendChild(script)
    },
    [onScriptLoaded]
  )

  useEffect(() => {
    if (isVisible) {
      if (canUseDOM && !window.zE && !window.zESettings) {
        const zESettings = getZESettings()
        insertScript(ZENDESK_KEY)
        window.zESettings = { ...zESettings }

        const waitForZE = setInterval(() => {
          if (window.zE === undefined || typeof window.zE !== 'function') {
            return
          }
          window.zE(function () {
            window.zE.identify(getVisitorInfo())
          })
          clearInterval(waitForZE)
        }, 100)
      }
      const zEIframe = document.getElementById('launcher')
      if (zEIframe) {
        zEIframe.style.display = 'block'
      }
    } else {
      if (!canUseDOM) {
        return
      }
      window.zE = null
      window.zESettings = null
      const zEIframe = document.getElementById('launcher')
      if (zEIframe) {
        zEIframe.style.display = 'none'
      }
    }
  }, [insertScript, isVisible])

  return null
}

export default Zendesk
